import { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Outlet, NavLink } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import { canImpersonate } from '@/components/business/support-impersonation'

import { selectUserData } from '../../reducers/userDataReducer'
import Dashboard from '../Dashboard'

class UserPanel extends Component {
  render() {
    const { user, fromFacebook } = this.props.userData
    const { t } = this.props

    const routes = [
      { path: '/dashboard/user-panel/profile', name: t('user-panel:userPanel.tabs.profile') },
      {
        path: '/dashboard/user-panel/notifications',
        name: t('user-panel:userPanel.tabs.notifications'),
        hidden:
          user.role !== 'Administrator' &&
          user.role !== 'PropertyManager' &&
          user.role !== 'ShiftManager' &&
          user.role !== 'Staff',
      },
      {
        path: '/dashboard/user-panel/password',
        name: t('user-panel:userPanel.tabs.password'),
        hidden: fromFacebook,
      },
      {
        path: '/dashboard/user-panel/impersonation',
        name: t('user-panel:userPanel.tabs.impersonation'),
        hidden: !canImpersonate(this.props.userData),
      },
    ]

    return (
      <Dashboard.Container className="ctp-userpanel">
        <div className="ctp-userpanel__inner">
          <div className="user-panel-header">
            <h1 className="user-panel-header__title">{t('user-panel:userPanel.title')}</h1>
          </div>

          <div className="user-panel-tabs">
            {routes
              .filter(({ hidden }) => !hidden)
              .map(({ path, name }) => (
                <NavLink
                  key={name}
                  to={path}
                  className={({ isActive }) =>
                    `user-panel-tabs__tab ${isActive ? 'user-panel-tabs__tab--active' : ''}`
                  }
                >
                  {name}
                </NavLink>
              ))}
          </div>

          <div className="user-panel-content">
            <Outlet />
          </div>
        </div>
      </Dashboard.Container>
    )
  }
}

UserPanel.propTypes = {
  userData: PropTypes.object,
  children: PropTypes.element,
  t: PropTypes.func,
}

export default connect((state) => ({ userData: selectUserData(state) }))(
  withTranslation(['user-panel'])(UserPanel),
)
